import muster from '@dbk-legacy/muster';
import { getValues } from '@dbk-legacy/muster/utils';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { DOCSIGN_API_ERROR_CODES } from '../../../constants';
import Guid from '../../../utils/guid';
import { DOCSIGN_PATH, ESIGN_BANNER_ARG } from './docsign-muster-constants';
import { variable } from '@dbk-legacy/muster/helpers';
import { encode } from 'base-64';

export default () => {
  return muster()
    .path('docsign.getClientSub', {
      call: async ({ req }, { get, set }) => {
        const [messages] = await getValues(get('i18n.messages'));
        const inputs = `${ESIGN_BANNER_ARG}`;
        const guidStr = Guid();
        const [result] = await getValues(get(`${DOCSIGN_PATH}.getClientSub["${inputs}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (getClientSubscriptionResponse) => {
          if (getClientSubscriptionResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || getClientSubscriptionResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
            await set('docsign.subscriptionData', getClientSubscriptionResponse.data.ackStatus);
          } else {
            await set('docsign.getClientSubscriptionErrorMessage', messages['app.digisign.error.tryagain']);
          }
        }).catch(async () => {
          await set('docsign.getClientSubscriptionErrorMessage', messages['app.digisign.error.tryagain']);
        });
      }
    })
    .path('docsign.saveClientSub', {
      call: async ({ req }, { get, set }) => {
        const [messages] = await getValues(get('i18n.messages'));
        const ackStatus = req.args[0];
        const base64 = encode(JSON.stringify(ackStatus));
        const inputs = `${ESIGN_BANNER_ARG}#@#${base64}`;
        const guidStr = Guid();
        const [result] = await getValues(get(`${DOCSIGN_PATH}.saveClientSub["${inputs}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (saveClientSubscriptionResponse) => {
          if (saveClientSubscriptionResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || saveClientSubscriptionResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
            await set('docsign.saveClientSubscriptionResponse', saveClientSubscriptionResponse.data);
          } else {
            await set('docsign.saveClientSubscriptionErrorMessage', messages['app.digisign.error.tryagain']);
          }
        }).catch(async () => {
          await set('docsign.saveClientSubscriptionErrorMessage', messages['app.digisign.error.tryagain']);
        });
      },
    })

    .path('docsign.subscriptionData', variable([]))
    .path('docsign.saveClientSubscriptionResponse', variable(null))
    .path('docsign.showAcceptSignModal', variable(false))
    .path('docsign.firstTimeSubscription', variable(false))
    .path('docsign.getSubscriptionDataError', variable(false))
    .path('docsign.getClientSubscriptionErrorMessage', variable(''))
    .path('docsign.saveClientSubscriptionErrorMessage', variable(''));

};
